import store from '../store'
import { i18nInstance } from './localization'
import { toastInstance } from './toast'
import MultiCurrencyCell from '~/components/form/multi-currency/multi-currency-cell'
import validators, { isEmpty, VCustom } from '~/statics/validators.js'
import MultiCurrencyCellView from '~/components/form/multi-currency/multi-currency-cell-view'
import Merge from 'lodash/merge'
import PersianDate from 'persian-date'
import dialog from '@/plugins/nikan-dialog-plugin'
import $sc from '@/plugins/shortcut.collection'

class FormUtility {

  loadIfPossible(methods = Object, data = Object, toast = Object, navigateOptions = null, additionalBroadcastFields = {}) {
    const directionTranslator = (direction) => i18nInstance.global.t(direction.toLowerCase())
    const allowedToChangeCodeForms = [
      'product-modify',
      'account-modify',
    ]
    const checkChangingCode = (isChanged, fromNavigate = false) => {
      const localChangeFormAlert = () => {
        if (isChanged) {
          methods.changedFormAlert(methods.clearForm)
            .then((res) => { return })
            .catch((err) => { return })
        } else {
          if (toast.useToast) {
            if (navigateOptions)
              toastInstance(i18nInstance.global.t('not-found-for-toast-navigation', { type: toast.keyword, direction: directionTranslator(navigateOptions.direction) }), toast.configs)
            else
              toastInstance(i18nInstance.global.t('not-found-for-toast', { code: data.searchCode, type: toast.keyword }), toast.configs)
          }
          if (!fromNavigate || navigateOptions.clearForm)
            setTimeout(methods.clearForm, 500)
        }
      }

      localChangeFormAlert()
      // if(isEmpty(data.originalData?.id) || navigateOptions || !methods.formType || (methods.formType && !allowedToChangeCodeForms.includes(methods.formType()))){
      //   localChangeFormAlert()
      // }
      // else {
      //   dialog({
      //     title: i18nInstance.global.t('do-you-want-to-change-code-title'),
      //     body: i18nInstance.global.t('do-you-want-to-change-code-body', {
      //       // fromCode: data.originalData.code,
      //       code: data.searchCode,
      //     }),
      //     buttons: [
      //       {
      //         title: i18nInstance.global.t('do-you-want-to-change-code-yes',{fromCode: data.originalData.code,toCode:data.searchCode}),
      //         shortcut: $sc.find('yes', 'dialog'),
      //         isPrimary: true,
      //         handle: (button, page, e) => {
      //           methods.save()?.then((res)=>methods.clearForm()).catch(()=>{})
      //         },
      //       },
      //       {
      //         title: i18nInstance.global.t('do-you-want-to-change-code-no'),
      //         shortcut: $sc.find('no', 'dialog'),
      //         isPrimary: true,
      //         handle: (button, page, e) => {
      //           localChangeFormAlert()
      //         },
      //       }
      //     ],
      //   }).catch(()=>{})
      // }
    }
    const onCatch = (err, fromNavigate = false) => {

      // Not found and state is edit and its not navigate because in navigate we don't want the form to be cleared
      if (err && err.exception && err.exception.response.status == 444 && !methods.retreiveIsEmpty()) {
        methods.isDataChanged().then((isChanged) => {
          checkChangingCode(isChanged, fromNavigate)
        })
      }
    }

    const onSuccess = (response) => {
      methods.isDataChanged().then((isChanged) => {
        // if(isEmpty(response.id) && (methods.formType && allowedToChangeCodeForms.includes(methods.formType())))
        //   checkChangingCode(isChanged)
        // else
        if (isChanged) {
          methods.changedFormAlert(methods.fillData, response)
            .then((res) => { return })
            .catch((err) => { return })
        } else {
          methods.fillData(response)
        }
      })
    }

    let defaultToastConfigs = { keyword: 'آیتم', useToast: true, configs: { type: 'info' } }
    toast = Merge(defaultToastConfigs, toast)
    if (data.originalData && data.searchCode === data.originalData.code && (typeof (methods.forceLoad) === 'function' ? !methods.forceLoad() : true))
      return

    if (store.getters['formCodes/isCodeInNotFoundArray'](toast.keyword, data.searchCode, additionalBroadcastFields)) {
      onCatch({ exception: { response: { status: 444 } } })
      return
    }

    if (data.searchCode == 0) {
      methods.isDataChanged().then((isChanged) => {
        if (isChanged) {
          methods.changedFormAlert(methods.clearForm)
            .then((res) => { return })
            .catch((err) => { return })
        } else {
          methods.clearForm()
        }
      })
      return
    }

    if (methods.navigate && navigateOptions)
      methods.navigate(navigateOptions.direction, navigateOptions.id).then(response => {
        // test error for not found with response code 200
        if (!response)
          throw new Error({ exception: { response: { status: 444 } } })
        onSuccess(response)
      })
        .catch(err => { // Not found
          onCatch(err, true)
          return err
        })

    else {
      methods.getData(data).then(response => { // Transaction found and state is either new or edit
        onSuccess(response)
      })
        .catch(err => { // Not found
          onCatch(err)
          store.dispatch('socket/broadcastItemNotExist', { form: toast.keyword, code: data.searchCode, additionalBroadcastFields })
          return err
        })
    }
  }

  getTodaysDate(splitter = '-', type = 'gregorian') {
    const differenceInMilliSecond = store.getters['appContext/getClientDifferenceDateTimeByServer']
    let date = new Date(Date.now() + differenceInMilliSecond)
    var dd = String(date.getDate()).padStart(2, '0')
    var mm = String(date.getMonth() + 1).padStart(2, '0') //January is 0!
    var hh = String(date.getHours()).padStart(2, '0')
    var minu = String(date.getMinutes()).padStart(2, '0')
    var ss = String(date.getSeconds()).padStart(2, '0')
    var yyyy = date.getFullYear()
    let final = `${yyyy}${splitter}${mm}${splitter}${dd}T${hh}:${minu}:${ss}`
    if (type === 'solar') {
      final = new PersianDate(diff).format(`YYYY${splitter}MM${splitter}DDThh:MM:ss`).toString().toEnglishDigits()
    }
    return final
  }

  setCurrencyColumns(list, tableOptions, mode, isAgGrid = false) {
    let companyCurrencyLength = store.getters['currencies/companyCurrencies'].filter(
      (x) => x.isEnabled
    ).length
    let columns = tableOptions.columns ? tableOptions.columns : tableOptions.columnDefs
    let currentPaymentHasCurrency = false
    if (list && list.length > 0) {
      list.map((x) => {
        if (x.currency && x.currency.id != emptyId)
          currentPaymentHasCurrency = true
      })
    }

    if (companyCurrencyLength < 2 && !currentPaymentHasCurrency) {
      columns = columns.filter(
        (x) => !x.currency
      )
      return
    }

    if (columns.filter((x) => !x.currency).length == 3)
      return

    columns = columns.filter(
      (x) => !x.currency
    )
    let start = columns.findIndex((x) => x.name === 'attachedAmount' || x.name === 'currencyValues' || x.field === 'currencyValues')
    let tableCols
    if (mode == 'view') tableCols = this.retreiveCurrencyColsView(tableOptions.columnDefs)
    else if (mode == 'editable') tableCols = this.retreiveCurrencyColsEditable(isAgGrid)
    columns.splice(start + 1, 0, ...tableCols)
    tableOptions.columns ? tableOptions.columns = columns : tableOptions.columnDefs = columns
  }

  retreiveCurrencyColsView(agGridColumns) {
    if (agGridColumns)
      return [
        {
          field: 'currencyValues',
          contentType: 'enum',
          headerName: i18nInstance.global.t('document.f.currency'),
          width: 100,
          valueFormatter: (data) => {
            return Array.isArray(data.value) ? data.value.map(x => x?.currency?.name).join(' | ') : ''
          },
          // cellRenderer: MultiCurrencyCellView,
          // cellRendererParams : (data)=>{
          //   return {
          //     options: {
          //       targetValuePropertyName: 'currency',
          //       // value: data.value
          //     },
          //   }
          // },
          aggFunc: 'count'
        },
        {
          field: 'currencyValues',
          headerName: i18nInstance.global.t('document.f.currencyRate'),
          width: 100,
          contentType: 'enum',
          valueFormatter: (data) => {
            return Array.isArray(data.value) ? data.value.map(x => x.currencyRate.toString().toPriceFormat()).join(' | ') : ''
          },
          // cellRenderer: MultiCurrencyCellView,
          // cellRendererParams : {
          //   options: {
          //     targetValuePropertyName: 'currencyRate',
          //   }
          // },
        },
        {
          field: 'currencyValues',
          headerName: i18nInstance.global.t('trs.transaction.f.currency-price'),
          width: 100,
          contentType: 'enum',
          valueFormatter: (data) => {
            return Array.isArray(data.value) ? data.value.map(x => x.debitCurrency.toString().toPriceFormat()).join(' | ') : ''
          },
          // cellRenderer: MultiCurrencyCellView,
          // cellRendererParams : {
          //   options: {
          //     targetValuePropertyName: 'debitCurrency',
          //   }
          // },
        },
      ]
    else
      return [
        {
          name: 'currencyValues',
          type: 'text',
          currency: true,
          title: i18nInstance.global.t('document.f.currency'),
          width: 100,
          editable: false,
          search: {
            searchFields: ['currency.name'],
          },
          view: (row, col) => {
            return {
              component: MultiCurrencyCellView,
              options: {
                targetValuePropertyName: 'currency',
              },
            }
          },
          leaving: true,
          pinned: false,
          entering: false,
        },
        {
          name: 'currencyValues',
          currency: true,
          title: i18nInstance.global.t('document.f.currencyRate'),
          width: 100,
          editable: false,
          search: {
            searchFields: ['currencyRate'],
          },
          view: (row, col) => {
            return {
              component: MultiCurrencyCellView,
              options: {
                targetValuePropertyName: 'currencyRate',
              },
            }
          },
          leaving: true,
          pinned: false,
          entering: false
        },
        {
          name: 'currencyValues',
          currency: true,
          title: i18nInstance.global.t('trs.transaction.f.currency-price'),
          width: 100,
          editable: false,
          search: {
            searchFields: ['debitCurrency'],
          },
          view: (row, col) => {
            return {
              component: MultiCurrencyCellView,
              options: {
                targetValuePropertyName: 'debitCurrency',
              },
            }
          },
          leaving: true,
          pinned: false,
          entering: false,
        },
      ]
  }

  retreiveCurrencyColsEditable(isAgGrid) {
    if (isAgGrid)
      return [
        {
          field: 'currencyValues',
          headerName: i18nInstance.global.t('document.f.currency'),
          width: 100,
          isEditable: true,
          type: 'multiCurrency',
          cellDataType: 'object',
          cellRendererParams: {
            options: {
              targetValuePropertyName: 'currency',
            },
          },
          cellEditorParams: {
            options: () => {
              return {
                targetValuePropertyName: 'currency',
              }
            }
          },
          validators: validators(
            new VCustom(
              (currencyValues, row) => {
                if (
                  (!row.accountTheir || !row.accountTheir.acceptsCurrency) &&
                  (!row.accountOur || !row.accountOur.acceptsCurrency)
                )
                  return true

                if (!currencyValues || !currencyValues.length) return false

                let allZero =
                  currencyValues.filter((x) => !x.currency).length === 0 &&
                  currencyValues.filter((x) => x.debit > 0).length === 0
                if (allZero) return false

                return true
              },
              () => {
                return i18nInstance.global.t('document.m.account-required-currency')
              }
            )
          ),
        },
        {
          field: 'currencyValues',
          headerName: i18nInstance.global.t('document.f.currencyRate'),
          width: 100,
          type: 'multiCurrency',
          cellDataType: 'object',
          isEditable: true,
          cellRendererParams: {
            options: {
              targetValuePropertyName: 'currencyRate',
            },
          },
          cellEditorParams: {
            options: () => {
              return {
                targetValuePropertyName: 'currencyRate',
              }
            }
          },
        },
        {
          field: 'currencyValues',
          headerName: i18nInstance.global.t('trs.transaction.f.currency-price'),
          width: 100,
          type: 'multiCurrency',
          cellDataType: 'object',
          isEditable: true,
          cellRendererParams: {
            options: {
              targetValuePropertyName: 'debitCurrency',
            },
          },
          cellEditorParams: {
            options: () => {
              return {
                targetValuePropertyName: 'debitCurrency',
              }
            }
          },
          validators: validators(
            new VCustom(
              (currencyValues, row) => {
                if (
                  (!row.accountTheir || !row.accountTheir.acceptsCurrency) &&
                  (!row.accountOur || !row.accountOur.acceptsCurrency)
                )
                  return true

                if (!currencyValues || !currencyValues.length) return false

                let allZero =
                  currencyValues.filter((x) => x.debitCurrency > 0).length === 0
                  && currencyValues.filter((x) => x.debit > 0).length > 0
                if (allZero) return false

                return true
              },
              () => {
                return i18nInstance.global.t('document.m.account-required-currency')
              }
            )
          ),
        },
      ]
    else
      return [
        {
          name: 'currencyValues',
          currency: true,
          title: i18nInstance.global.t('document.f.currency'),
          width: 100,
          editable: true,
          view: (row, col) => {
            return {
              component: MultiCurrencyCellView,
              options: {
                targetValuePropertyName: 'currency',
              },
            }
          },
          edit: {
            component: MultiCurrencyCell,
            options: {
              targetValuePropertyName: 'currency',
            },
          },
          validators: validators(
            new VCustom(
              (currencyValues, row) => {
                if (
                  (!row.accountTheir || !row.accountTheir.acceptsCurrency) &&
                  (!row.accountOur || !row.accountOur.acceptsCurrency)
                )
                  return true

                if (!currencyValues || !currencyValues.length) return false

                let allZero =
                  currencyValues.filter((x) => !x.currency).length === 0 &&
                  currencyValues.filter((x) => x.debit > 0).length === 0
                if (allZero) return false

                return true
              },
              () => {
                return i18nInstance.global.t('document.m.account-required-currency')
              }
            )
          ),
          leaving: (row) => {
            return true
          },
          pinned: false,
          entering: (row) => {
            return true
          },
        },
        {
          name: 'currencyValues',
          currency: true,
          title: i18nInstance.global.t('document.f.currencyRate'),
          width: 100,
          editable: true,
          view: (row, col) => {
            return {
              component: MultiCurrencyCellView,
              options: {
                targetValuePropertyName: 'currencyRate',
              },
            }
          },
          edit: {
            component: MultiCurrencyCell,
            options: {
              targetValuePropertyName: 'currencyRate',
            },
          },
          leaving: (row) => {
            return true
          },
          pinned: false,
          entering: (row) => {
            return true
          },
        },
        {
          name: 'currencyValues',
          currency: true,
          title: i18nInstance.global.t('trs.transaction.f.currency-price'),
          width: 100,
          editable: true,
          view: (row, col) => {
            return {
              component: MultiCurrencyCellView,
              options: {
                targetValuePropertyName: 'debitCurrency',
              },
            }
          },
          edit: {
            component: MultiCurrencyCell,
            options: {
              targetValuePropertyName: 'debitCurrency',
            },
          },
          leaving: (row) => {
            return true
          },
          validators: validators(
            new VCustom(
              (currencyValues, row) => {
                if (
                  (!row.accountTheir || !row.accountTheir.acceptsCurrency) &&
                  (!row.accountOur || !row.accountOur.acceptsCurrency)
                )
                  return true

                if (!currencyValues || !currencyValues.length) return false

                let allZero =
                  currencyValues.filter((x) => x.debitCurrency > 0).length === 0
                  && currencyValues.filter((x) => x.debit > 0).length > 0
                if (allZero) return false

                return true
              },
              () => {
                return i18nInstance.global.t('document.m.account-required-currency')
              }
            )
          ),
          pinned: false,
          entering: (row) => {
            return true
          },
        },
      ]
  }
  switchMode(pageButtons, mode) {
    switch (mode) {
      case 'edit':
        pageButtons.saveButton.disabled = false
        pageButtons.selectButton.disabled = true
        break
      case 'select':
        pageButtons.saveButton.disabled = true
        pageButtons.selectButton.disabled = false
        break
      default:
        throw new Error('Mode is not currect, use (edit/select).')
    }
  }
}

const _FormUtility = new FormUtility()
export default _FormUtility
